import FormProvider, { RHFSelect, RHFTextField } from '@/commons/hook-form';
import { useForm } from 'react-hook-form';
import { ITableAccountGeneral } from '../../types';
import { yupResolver } from '@hookform/resolvers/yup';
import { newTableSchema } from './validation';
import { Box, Card, Grid, Stack } from '@mui/material';
import { Button } from '@PorkyCol/button';
import { useEffect, useMemo, useState } from 'react';
import { defaultValuesTableForm } from './initial-values';
import { translates } from '@/utils';

type FormValuesProps = Partial<ITableAccountGeneral>;

export default function TableNewEditForm ({current, onSave}: any) {
  const [figure, setFigure] = useState('')
  const defaultValues = useMemo(
    () => defaultValuesTableForm(current),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [current]
  );

  const methods = useForm<FormValuesProps>({
    resolver: yupResolver( newTableSchema),
    defaultValues,
  });

  const { reset, watch, control, handleSubmit } = methods;

  useEffect(() => {
    if (current) {
      reset(defaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  const onSubmit = async (data: any) => {
    try {
      await onSave(data);
      reset();
    } catch (error) {
      console.error(error);
    }
  };

  return(
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Card sx={{ p: 3, gap: 2 }}>
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <RHFTextField name="name" label={translates.new_table} />
              <RHFSelect native name="status" label={translates.state_table} fullWidth>
                <option value="" selected disabled hidden />
                <option value='AVAILABLE'>
                  {translates.available_table}
                </option>
                <option value='BUSY'>
                  {translates.busy_table}
                </option>
              </RHFSelect>
              <RHFTextField name="customers" label={translates.customers_table} />
              <RHFSelect native name="figure" label={translates.figure_table} fullWidth>
                <option value="" selected disabled hidden />
                <option value='triangle'>
                  {translates.triangle_table}
                </option>
                <option value='circle'>
                  {translates.circle_table}
                </option>
                <option value='rectangle'>
                  {translates.rectangle_table}
                </option>
                <option value='square'>
                  {translates.square_table}
                </option>
              </RHFSelect>
            </Box>

            <Stack alignItems="flex-end" sx={{ mt: 3 }}>
              <Button type="submit" variant="solid" loading={false} color="success">
                {/* {!isEdit ? [translates.create + translates.user] : [translates.saveChanges]} */}
                Crear Mesa
              </Button>
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
